import common from './reducers/common'
import home from './reducers/home'
import auth from './reducers/auth'
import asset from './reducers/asset'
import account from './reducers/account'
import settings from './reducers/settings'
import trade from './reducers/trade'
import news from './reducers/news'
import certificate from './reducers/certificate'
import file from './reducers/file'
import { combineReducers } from 'redux'
import { routerReducer } from 'react-router-redux'

export default combineReducers({
  common,
  home,
  auth,
  asset,
  account,
  settings,
  trade,
  news,
  certificate,
  file,
  router: routerReducer
})
